import styled from 'styled-components';
import { ThemeColours, transparentThemeColour } from '../../../../styles/ThemeColours';
import { FONT_STACK } from '../../../../styles/constants';
import { VERTICAL_SCROLL_SHADOWS } from '../../../../styles/mixins';

export const MobileContent = styled.ul`
  ${VERTICAL_SCROLL_SHADOWS}
  background-color: white;
  cursor: pointer;
  list-style: none;
  overflow-x: none;
  overflow-y: scroll;
  padding: 0;
  user-select: none;

  li {
    padding: 16px !important;
  }
`;

export const ContentWrapper = styled.ul`
  background-color: ${ThemeColours.white};
  border: 1px solid ${ThemeColours.mono500};
  border-radius: 4px;
  box-shadow: 0px 1px 10px ${transparentThemeColour('mono600', 0.15)};
  box-sizing: border-box;
  cursor: pointer;
  list-style: none;
  overflow-y: scroll;
  padding: 0px;
  position: absolute;
  right: 0px;
  top: 20px;
  user-select: none;

  width: 244px;
`;

export const List = styled.li`
  ${FONT_STACK};
  padding: 12px 16px;

  &:hover {
    background-color: ${ThemeColours.mono100};
  }
`;
